import { styled } from "@mui/material";
const Item = styled("div", {
  name: "TruncateItem",
  slot: "Root"
})`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export {
  Item
};
//# sourceMappingURL=Item.js.map
